import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QueueService } from '../../services/queue.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Queue, QueueStatus, QueueTrigger } from '../../interfaces/queue.interface';
import { AdminQueueLinkOverviewDetailedComponent } from './admin-queue-link-overview-detailed/admin-queue-link-overview-detailed.component';
import { DxiColumnModule, DxoFilterBuilderModule, DxoFilterBuilderPopupModule, DxoFilterPanelModule, DxoFilterRowModule, DxoHeaderFilterModule, DxoMasterDetailModule, DxoPagingModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule } from 'devextreme-angular';

@Component({
	selector: 'app-shell-admin-queue-link-overview',
	templateUrl: './admin-queue-link-overview.component.html',
	styleUrls: ['./admin-queue-link-overview.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, AsyncPipe, DxDateBoxModule,  DxDropDownBoxModule, AdminQueueLinkOverviewDetailedComponent, DxoMasterDetailModule, DxoHeaderFilterModule, DxoFilterRowModule, DxoFilterBuilderModule, DxoFilterBuilderPopupModule, DxoFilterPanelModule, DxiColumnModule, DxoPagingModule, DxDataGridModule]
})
export class AdminQueueLinkOverviewComponent {
	queueEntries$: Observable<Queue[]> = new Observable<Queue[]>();
	queueStatusses$: BehaviorSubject<{ numberValue: number; queueStatusString: string }[]> = new BehaviorSubject<
		{ numberValue: number; queueStatusString: string }[]
	>([]);

	gridBoxValue: number[] = [];

	//We don't want to retrieve too much data, so we only retrieve the last 7 days by defaut
	toDate: Date = new Date(); // Get the current date
	fromDate: Date = new Date(this.toDate.getTime() - 7 * 24 * 60 * 60 * 1000); // Subtract 7 days in milliseconds
	/**
	 *
	 */
	constructor(private queueService: QueueService) {
		this.queueService.getQueueStatusList().subscribe(e => {
			this.queueStatusses$.next(this.numArrayToObjectArray(QueueStatus, e));
		});
	}

	numArrayToObjectArray(enumObj: any, enumValues: number[]): { numberValue: number; queueStatusString: string }[] {
		return enumValues.map(value => ({
			numberValue: value,
			queueStatusString: String(enumObj[value]),
		}));
	}

	getEnumStringValueQueueStatus(number: number) {
		return String(QueueStatus[number]);
	}

	getEnumStringValueQueueTriggerStatus(number: number) {
		return String(QueueTrigger[number]);
	}

	requestData() {
		this.queueEntries$ = this.queueService.getAllQueueEntries({
			fromDate: this.fromDate,
			toDate: this.toDate,
			queueStatusFilter: this.gridBoxValue,
		});
	}

	getTimeDifference(start1: Date, end1: Date, queueStatus: number): string {
		const end = new Date(end1);
		const start = new Date(start1);

		if (end.getFullYear() < 2000) {
			return 'Unknown';
		}

		const timeDiff = end.getTime() - start.getTime(); // Get the time difference in milliseconds
		const isNegative = timeDiff < 0;

		// Convert milliseconds to days, hours, minutes, and seconds
		const absoluteTimeDiff = Math.abs(timeDiff);
		const days = Math.floor(absoluteTimeDiff / (1000 * 60 * 60 * 24));
		const hours = Math.floor((absoluteTimeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((absoluteTimeDiff % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((absoluteTimeDiff % (1000 * 60)) / 1000);

		// Generate the human-readable time difference string
		const timeParts: string[] = [];
		if (days > 0) {
			timeParts.push(`${days}d`);
		}
		if (hours > 0) {
			timeParts.push(`${hours}h`);
		}
		if (minutes > 0) {
			timeParts.push(`${minutes}m`);
		}
		if (seconds > 0) {
			timeParts.push(`${seconds}s`);
		}

		// Join the time parts with commas and 'and' for readability
		let formattedTime = '';
		if (timeParts.length === 1) {
			formattedTime = timeParts[0];
		} else if (timeParts.length > 1) {
			const lastPart = timeParts.pop();
			formattedTime = timeParts.join(', ') + ' and ' + lastPart;
		}

		// Add a prefix for negative time differences
		formattedTime = isNegative ? '-' + formattedTime : formattedTime;

		if (isNegative && queueStatus == QueueStatus.Waiting) {
			return formattedTime + ' - Expected to be executed';
		}

		return formattedTime;
	}

	getUtcNow(): Date {
		const now = new Date();
		const utcNow = new Date(
			now.getUTCFullYear(),
			now.getUTCMonth(),
			now.getUTCDate(),
			now.getUTCHours(),
			now.getUTCMinutes(),
			now.getUTCSeconds(),
			now.getUTCMilliseconds()
		);

		return utcNow;
	}
}
